import { withChildren } from '@builder.io/react';
import { createBuilderModule } from '../../../register-builder/builder-module';
import { blockElement } from '../../../register-builder/element-factories';
import { CarouselSection } from './CarouselSection';

const carouselBlockDefaults = {
  isPageWidth: false,
  heading: 'Default Heading',
  headingStyle: 'sectionHeader3',
  content: 'This is the default content. Please edit me!',
  contentStyle: 'paragraph1',
  textPlacement: 'left',
  align: 'left',
  ctaText: 'Read full story',
  ctaStyle: 'tertiary',
  ctaHref: '/EDIT-ME',
} as const;

const defaultCarouselBlock = blockElement({
  ...carouselBlockDefaults,
  heading: 'A default heading',
  mediaSrc: 'https://cdn.zappy.app/6db2607df31caecba4c910998dba31af.png',
});

const defaultCarouselBlock02 = blockElement({
  ...carouselBlockDefaults,
  heading: 'Another default heading',
  mediaSrc: 'https://cdn.zappy.app/d97ad9e5fcd0954be8f4852bae178cab.png',
});

export default createBuilderModule(withChildren(CarouselSection), {
  name: 'CarouselSection',
  image: 'https://cdn.zappy.app/70bef4e8e2b54f2a55972f5c147e48c6.png',
  inputs: [
    {
      name: 'subheading',
      type: 'string',
      defaultValue: 'Section Subheading',
    },
    {
      name: 'heading',
      type: 'string',
      defaultValue: 'Section Heading',
    },
  ],
  defaultChildren: [
    defaultCarouselBlock,
    defaultCarouselBlock02,
    defaultCarouselBlock,
    defaultCarouselBlock02,
  ],
});
